"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelFilters = exports.MISSING_LABEL_FILTER_ERROR_MESSAGE = void 0;
const tslib_1 = require("tslib");
const lodash_1 = require("lodash");
const react_1 = tslib_1.__importStar(require("react"));
const EditorField_1 = require("../../QueryEditor/EditorField");
const EditorFieldGroup_1 = require("../../QueryEditor/EditorFieldGroup");
const EditorList_1 = require("../../QueryEditor/EditorList");
const LabelFilterItem_1 = require("./LabelFilterItem");
exports.MISSING_LABEL_FILTER_ERROR_MESSAGE = 'Select at least 1 label filter (label and value)';
function LabelFilters({ labelsFilters, onChange, onGetLabelNames, onGetLabelValues, labelFilterRequired, multiValueSeparator, }) {
    const defaultOp = '=';
    const [items, setItems] = (0, react_1.useState)([{ op: defaultOp }]);
    (0, react_1.useEffect)(() => {
        if (labelsFilters.length > 0) {
            setItems(labelsFilters);
        }
        else {
            setItems([{ op: defaultOp }]);
        }
    }, [labelsFilters]);
    const onLabelsChange = (newItems) => {
        setItems(newItems);
        // Extract full label filters with both label & value
        const newLabels = newItems.filter((item) => item.label !== undefined && item.value !== undefined);
        if (!(0, lodash_1.isEqual)(newLabels, labelsFilters)) {
            onChange(newLabels);
        }
    };
    const hasLabelFilter = items.some((item) => item.label && item.value);
    return (react_1.default.createElement(EditorFieldGroup_1.EditorFieldGroup, null,
        react_1.default.createElement(EditorField_1.EditorField, { label: "Label filters", error: exports.MISSING_LABEL_FILTER_ERROR_MESSAGE, invalid: labelFilterRequired && !hasLabelFilter },
            react_1.default.createElement(EditorList_1.EditorList, { items: items, onChange: onLabelsChange, renderItem: (item, onChangeItem, onDelete) => (react_1.default.createElement(LabelFilterItem_1.LabelFilterItem, { item: item, items: items, defaultOp: defaultOp, onChange: onChangeItem, onDelete: onDelete, onGetLabelNames: onGetLabelNames, onGetLabelValues: onGetLabelValues, invalidLabel: labelFilterRequired && !item.label, invalidValue: labelFilterRequired && !item.value, multiValueSeparator: multiValueSeparator })) }))));
}
exports.LabelFilters = LabelFilters;
//# sourceMappingURL=LabelFilters.js.map